import { useState } from "react";
import { MessageCircle } from "lucide-react";
import { RemansoFigure } from "@/components/Brand";
import { Sheet } from "@/components/Sheet";
import { CrisisNote } from "@/components/CrisisNote";
import { RemansoControls, RemansoThread } from "@/components/RemansoThread";
import { RouteChooser } from "@/components/RouteChooser";
import { useRemanso } from "@/context/RemansoContext";

const HelpSheet = ({ open, onOpenChange }) => (
  <Sheet open={open} onOpenChange={onOpenChange} title="Ayuda las 24 horas" testId="help-sheet">
    <div className="rounded-[24px] bg-superficie p-5 space-y-4">
      <div>
        <p className="font-medium">Línea de la Vida</p>
        <p className="text-sm text-sec">Gratis, las 24 horas.</p>
        <a href="tel:8009112000" className="btn-primary mt-3" data-testid="help-call-linea">Llamar al 800 911 2000</a>
      </div>
      <div className="pt-4 border-t border-linea">
        <p className="font-medium">Si hay peligro inmediato</p>
        <a href="tel:911" className="btn-secondary mt-3" data-testid="help-call-911">Llamar al 911</a>
      </div>
    </div>
  </Sheet>
);

// taps on the bar (raised above the overlay) must not dismiss the thread first
const keepForBar = (e) => { if (e.target.closest?.("[data-testid=mobile-remanso-bar]")) e.preventDefault(); };

const ThreadSheet = ({ open, onOpenChange }) => {
  const { bound, thread, live, estado, openInfo } = useRemanso();
  return (
    <Sheet open={open} onOpenChange={onOpenChange} title="Remanso" testId="remanso-thread-sheet" onInteractOutside={keepForBar}>
      <button type="button" className="-mt-3 flex items-center gap-3 text-left rounded-[24px]" onClick={() => openInfo("historia")} data-testid="sheet-remanso-story-button">
        <RemansoFigure estado={estado} height={64} className="shrink-0" testId="sheet-remanso-figure" />
        <span className="text-sm text-sec">Acompaña sin aconsejar</span>
      </button>
      {bound && thread.length === 0 && !live && (
        <p className="text-sm text-sec" data-testid="remanso-thread-empty">Cuando pidas compañía, aquí aparecerán las preguntas de Remanso.</p>
      )}
      <RouteChooser prefix="sheet" />
      <RemansoThread prefix="sheet" />
      <RemansoControls prefix="sheet" />
      <div className="pt-4 border-t border-linea">
        <CrisisNote testId="thread-crisis-note" />
      </div>
      <div className="h-20 shrink-0" aria-hidden="true" />
    </Sheet>
  );
};

export const MobileRemansoBar = ({ helpOnly = false }) => {
  const { estado, panelOpen, setPanelOpen, bound, ask, openInfo } = useRemanso();
  const [helpOpen, setHelpOpen] = useState(false);
  const accompany = () => { setPanelOpen(true); if (bound) ask("ask"); };
  return (
    <>
      <div
        data-testid="mobile-remanso-bar"
        className={`lg:hidden fixed bottom-0 inset-x-0 pointer-events-auto ${panelOpen ? "z-[52]" : "z-40"} bg-superficie border-t border-linea px-3 pt-2.5 pb-[calc(0.625rem+env(safe-area-inset-bottom))] pl-[max(0.75rem,env(safe-area-inset-left))] pr-[max(0.75rem,env(safe-area-inset-right))] flex items-center gap-2`}
      >
        {!helpOnly && <>
        <button type="button" className="shrink-0 rounded-[24px]" aria-label={panelOpen ? "Conocer a los Remansos" : "Abrir a Remanso"}
          onClick={() => (panelOpen ? openInfo("historia") : setPanelOpen(true))} data-testid="mobile-remanso-figure-button">
          <RemansoFigure estado={estado} height={64} testId="mobile-remanso-figure" />
        </button>
        <button className="btn-primary px-4" onClick={accompany} data-testid="acompaname-button">
          Acompáñame
        </button>
        <button className="icon-btn" aria-label="Abrir el hilo de preguntas" onClick={() => setPanelOpen(true)} data-testid="open-thread-button">
          <MessageCircle size={20} strokeWidth={1.75} />
        </button>
        </>}
        <button className="btn-text ml-auto text-xs whitespace-nowrap" onClick={() => { setPanelOpen(false); setHelpOpen(true); }} data-testid="help-24h-link">
          Ayuda 24 h
        </button>
      </div>
      <ThreadSheet open={panelOpen} onOpenChange={setPanelOpen} />
      <HelpSheet open={helpOpen} onOpenChange={setHelpOpen} />
    </>
  );
};
